import TopDestinationsSlider from '@ui/Cms/TopDestinations/Slider/component'

export default (): void => {
  const topDestinationsEl = document.querySelector<HTMLElement>('.top-destinations-slider')
  topDestinationsEl && TopDestinationsSlider(topDestinationsEl)
}
